import { FilterSchema } from './types'

const registry = new Map<string, FilterSchema>()

export const registerFilters = (
  operationName: string,
  schema: FilterSchema,
): void => {
  registry.set(operationName, schema)
}

export const getFilters = (operationName: string): FilterSchema | undefined =>
  registry.get(operationName)
